// components/marketing/FactoryLoadingSkeleton.tsx
export function FactoryLoadingSkeleton() {
  return <section role="status" aria-label="Loading Factory" aria-busy="true" data-factory-loading="" className="h-full min-h-0 w-full flex-1 overflow-hidden px-6 py-6">
    <span className="sr-only">Loading Factory…</span>
    <div aria-hidden="true" className="mx-auto max-w-[1450px] motion-safe:animate-pulse">
      <div className="mb-8 flex flex-wrap gap-3">{[1, 2, 3].map(item => <div key={item} className="h-8 w-28 rounded-lg bg-[#2D2D2D]" />)}</div>
      <div className="mb-4 h-3 w-16 rounded bg-[#2D2D2D]" />
      <div className="grid grid-cols-[repeat(auto-fill,minmax(min(220px,100%),248px))] gap-4">
        {[1, 2, 3].map(item => <div key={item} className="flex h-[74px] items-center gap-4 rounded-2xl bg-white/[0.04] px-5"><div className="h-7 w-7 rounded bg-[#333333]" /><div className="h-3 w-24 rounded bg-[#333333]" /></div>)}
      </div>
      <div className="mt-4 w-full max-w-[248px] rounded-2xl bg-white/[0.04] p-5">
        <div className="mb-6 h-4 w-3/4 rounded bg-[#333333]" />
        {[100, 90, 95, 70, 85, 60].map((width, index) => <div key={index} className="mb-3 h-2 rounded bg-[#2D2D2D]" style={{ width: `${width}%` }} />)}
      </div>
      {['personas', 'archetypes'].map(section => <div key={section} className="mt-9">
        <div className="mb-4 h-4 w-24 rounded bg-[#333333]" />
        <div className="grid grid-cols-[repeat(auto-fill,minmax(min(220px,100%),248px))] gap-4">
          {[1, 2, 3].map(item => <div key={item} className="overflow-hidden rounded-2xl bg-white/[0.04]"><div className="aspect-[4/3] bg-[#2D2D2D]" /><div className="space-y-3 p-4"><div className="h-3 w-2/3 rounded bg-[#333333]" /><div className="h-2 w-1/3 rounded bg-[#2D2D2D]" /></div></div>)}
        </div>
      </div>)}
    </div>
  </section>;
}
